<template>
  <div>
    <LoadingSpinner :loading="caseLoading" />
    <b-row class="mx-0" v-show="!caseLoading">
      <b-col cols="12" md="12" class="mb-3">
        <b-alert :show="!!message" variant="info">
          <i class="fas fa-info-circle fa-lg mr-1" />
          <b v-html="message" />
        </b-alert>
      </b-col>
      <b-col
        v-if="!includes(caseStatusId, [5, 6])"
        cols="12"
        md="12"
        class="mb-3"
      >
        <AudioRecorder
          :code="pathOr(null, ['center_execute_code'], otherData)"
          :caseId="case_id"
          :candidateName="pathOr('', ['person', 'full_name'], candidateObject)"
          :exerciseName="renderExercise"
        />
      </b-col>
      <b-col v-if="competencies[0]" cols="12" md="12" class="mb-3">
        <strong v-text="`${$lang.exercise}: `" />
        <span v-text="renderExercise" />
      </b-col>
      <b-col
        v-if="competencies[0]"
        cols="12"
        :md="secondAssessorObject ? 4 : 6"
        class="mb-3"
      >
        <div class="bg-white border rounded p-1">
          <AvatarInfo
            :avatarAddress="pathOr(null, ['person', 'img'], candidateObject)"
            :title="
              pathOr('*****', ['person', 'full_name'], candidateObject) +
              ` (${$lang.candidate})`
            "
            :description="
              `${$lang.candidateCode}: ` +
              pathOr('', ['person_center_execute_code'], candidateObject)
            "
            :genderId="+pathOr(1, ['person', 'gender', 'id'], candidateObject)"
            :personCode="pathOr(null, ['person', 'code'], candidateObject)"
          />
        </div>
      </b-col>
      <b-col
        v-if="competencies[0]"
        cols="12"
        :md="secondAssessorObject ? 4 : 6"
        class="mb-3"
      >
        <div class="bg-white border rounded p-1">
          <AvatarInfo
            :avatarAddress="pathOr(null, ['person', 'img'], assessorObject)"
            :title="
              pathOr('*****', ['person', 'full_name'], assessorObject) +
              ` (${$lang.assessor})`
            "
            :description="
              `${$lang.assessorCode}: ` +
              pathOr('', ['person_center_execute_code'], assessorObject)
            "
            :genderId="+pathOr(1, ['person', 'gender', 'id'], assessorObject)"
            :personCode="pathOr(null, ['person', 'code'], assessorObject)"
          />
        </div>
      </b-col>
      <b-col
        v-if="competencies[0] && secondAssessorObject"
        cols="12"
        md="4"
        class="mb-3"
      >
        <div class="bg-white border rounded p-1">
          <AvatarInfo
            :avatarAddress="
              pathOr(null, ['person', 'img'], secondAssessorObject)
            "
            :title="
              pathOr('*****', ['person', 'full_name'], secondAssessorObject) +
              ` (${$lang.secondAssessor})`
            "
            :description="
              `${$lang.secondAssessorCode}: ` +
              pathOr('', ['person_center_execute_code'], secondAssessorObject)
            "
            :genderId="
              +pathOr(1, ['person', 'gender', 'id'], secondAssessorObject)
            "
            :personCode="pathOr(null, ['person', 'code'], secondAssessorObject)"
          />
        </div>
      </b-col>
      <b-col cols="12" md="12" class="mb-5">
        <b-tabs>
          <b-tab :lazy="true" active>
            <template v-slot:title>{{ $lang.marking_competency }}</template>
            <MarkingCompetency
              :center_execute_id="+center_execute_id"
              :case_id="+case_id"
              :competencies="competencies"
              :score_options="score_options"
              :case_status="case_status"
              :isScoreEditable="isScoreEditable"
              :isEditable="isEditable"
              :userExecutiveRoleId="userExecutiveRoleId"
              @competencyUpdated="fetchData"
            />
          </b-tab>
          <b-tab :lazy="true">
            <template v-slot:title
              >{{ $lang.case_overview }}
              <span v-b-tooltip.hover :title="$lang.case_overview_tooltip">
                <mdicon name="information" size="20" class="text-info" />
              </span>
            </template>
            <CaseOverview
              :center_execute_id="center_execute_id"
              :case_id="case_id"
              :competencies="competencies"
              :score_options="score_options"
              :dossier_status="case_status"
              :isEditable="isEditable"
              :userExecutiveRoleId="userExecutiveRoleId"
            />
          </b-tab>
          <b-tab :lazy="true">
            <template v-slot:title>
              {{ $lang.Content_participant }}
              <span v-b-tooltip.hover :title="$lang.competency_person_data">
                <mdicon name="information" size="20" class="text-info" />
              </span>
            </template>

            <b-alert :show="!isParvandehCode" variant="info">
              <mdicon name="information" size="20" class="mr-1" />
              <b v-text="$lang.no_competency_person_data" />
            </b-alert>
            <Search
              v-if="isParvandehCode"
              :allowCollapse="false"
              :url="competency_person_data_url"
              :allowFields="$lang.content_participant_fields"
              :hiddenFields="[]"
              :title="$lang.Content_participant_list"
              config="competencyPersonData"
              addModalSize="lg"
              removeModalSize="xl"
              :visibleSearch="true"
              :visibleSettings="true"
              :visibleExport="true"
              :visibleFilters="true"
              :visibleViewCount="true"
              :visibleAdd="true"
              :allowEdit="false"
              :dynamicButtons="buttonsCompetencyPersonData"
              :remove_item="removeItem"
              ref="competencyPersonData"
              @getPermisson="updatePermissions"
            >
              <template slot="addModal" slot-scope="search">
                <AddPersonContent
                  :caseId="case_id"
                  @closeModal="search.close"
                  @getItems="getData"
                />
              </template>
            </Search>
            <b-modal
              no-close-on-backdrop
              v-model="editModal"
              size="lg"
              ok-only
              hide-header
              hide-footer
            >
              <b-card>
                <div slot="header">مشاهده محتوای شرکت کننده</div>
                <LoadingSpinner :loading="isLoading" />
                <b-row v-if="!isLoading">
                  <b-col cols="12" md="12">
                    <strong v-text="'عنوان محتوا: '" />
                    <p
                      class="text-muted"
                      v-text="pathOr('', ['name'], currentItem)"
                    />
                  </b-col>
                  <b-col cols="12" md="12" class="mb-3">
                    <strong v-text="'توضیحات: '" />
                    <div
                      class="text-muted"
                      v-html="pathOr('', ['description'], currentItem)"
                    />
                  </b-col>
                  <b-col cols="12" md="12">
                    <UploadFile
                      title="پیوست محتوای شرکت کننده"
                      attachmentRoute="attachment"
                      :propAttachmentType="true"
                      :parent_attachment_type_options="
                        parentAttachmentTypeOptions
                      "
                      keyServies="person_content"
                      :keyValue="pathOr(null, ['id'], currentItem)"
                      attachment_type_name="attachment_type_center_execute"
                      :parentPermissions="permissions"
                      :file_types="file_types"
                      :showForm="true"
                      :crop="false"
                    />
                  </b-col>
                  <b-col cols="12" class="text-right mt-3">
                    <b-button
                      type="reset"
                      class="ml-2"
                      size="md"
                      variant="danger"
                      @click="closeModal"
                    >
                      {{ $lang.close }}
                      <i class="fa fa-ban" />
                    </b-button>
                  </b-col>
                </b-row>
              </b-card>
            </b-modal>
          </b-tab>
          <b-tab :lazy="true">
            <template v-slot:title>
              {{ $lang.exerciseEvaluationGuide }}
            </template>
            <div class="" v-html="exercise_guide" />
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import MarkingCompetency from "./markingCompetency";
import CaseOverview from "./caseOverview";
import Search from "@/components/base/search";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import UploadFile from "@/components/base/uploadFile";
import AvatarInfo from "@/components/global/AvatarInfo";
import AddPersonContent from "./addPersonContent.vue";
import { pathOr, includes } from "ramda";
import { isAdmin, generateApiUrl, renderEumOptions } from "@/shared/utils";
import AudioRecorder from "./AudioRecorder";

export default {
  name: "case-competency",
  inject: ["centerExecuteCompetencyRepository"],
  components: {
    MarkingCompetency,
    CaseOverview,
    Search,
    LoadingSpinner,
    UploadFile,
    AvatarInfo,
    AudioRecorder,
    AddPersonContent,
  },
  props: {
    center_execute_id: {
      type: [String, Number],
      default: null,
    },
    case_id: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      competencies: [],
      caseLoading: false,
      exercise_guide: "",
      case_status: {},
      buttonsCompetencyPersonData: [
        {
          id: "0",
          name: "edit",
          click: this.showEditModal,
        },
        {
          id: "2",
          name: "view",
          click: this.showEditModal,
        },
        {
          name: "delete",
        },
      ],
      permissions: [],
      editModal: false,
      isLoading: false,
      currentItem: {},
      file_types: ["image", "office", "media", "other"],
      caseStatusId: null,
      userExecutiveRoleId: null,
      isScoreEditable: false,
      isEditable: false,
      message: null,
      otherData: null,
      editPersonContentOutButton: [
        {
          id: "1",
          name: "edit",
        },
        {
          id: "0",
          name: "delete",
        },
      ],
    };
  },
  computed: {
    secondAssessorName() {
      const name = pathOr(
        null,
        ["0", "second_assessor", "name"],
        this.competencies
      );
      return name ? `/${name}` : "";
    },
    assessorName() {
      return pathOr(null, ["0", "assessor", "name"], this.competencies);
    },
    parentAttachmentTypeOptions() {
      return renderEumOptions("attachment_type_center_execute");
    },
    score_options() {
      return renderEumOptions("competency_score").map((item) => {
        if (!item.value) {
          item.text = item.text.replace("0", "w");
        }
        return item;
      });
    },
    renderExercise() {
      return pathOr("", ["0", "case", "exercise", "name"], this.competencies);
    },
    candidateObject() {
      return pathOr(null, ["0", "candidate"], this.competencies);
    },
    assessorObject() {
      return pathOr(null, ["0", "assessor"], this.competencies);
    },
    secondAssessorObject() {
      return pathOr(null, ["0", "second_assessor"], this.competencies);
    },
    isParvandehCode() {
      return pathOr(
        null,
        ["0", "candidate", "parvandeh_code"],
        this.competencies
      );
    },
    competency_person_data_url() {
      return generateApiUrl(
        ["kanoon", "center_execute_case_content"],
        [this.case_id]
      );
    },
  },
  async created() {
    this.fetchData();
  },
  methods: {
    pathOr,
    includes,
    isAdmin,
    generateApiUrl,
    renderEumOptions,
    updatePermissions(data) {
      this.permissions = data;
    },
    closeModal() {
      this.editModal = false;
    },
    getData() {
      this.$refs.competencyPersonData.getItems();
    },
    showEditModal(item) {
      this.editModal = true;
      const id = pathOr(null, ["id"], item);
      this.getPersonContent(id);
    },
    async getPersonContent(id) {
      try {
        this.isLoading = true;
        const url = generateApiUrl(["kanoon", "person_content_id"], [id]);
        const response = await this.$httpService.get(url);
        this.currentItem = pathOr({}, ["data", "data"], response);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    async fetchData(withLoading = true) {
      try {
        this.caseLoading = withLoading;
        const params = {
          is_enable: 1,
        };
        const response = await this.centerExecuteCompetencyRepository.list(
          this.center_execute_id,
          this.case_id,
          params
        );
        const data = pathOr(null, ["data", "data", "result"], response);
        this.otherData = pathOr(null, ["data", "other"], response);

        const competencies = data.competencies.map((x) => {
          x.active = false;
          x.competency.caption = x.competency.name;
          return x;
        });
        this.competencies = [...competencies];
        this.caseStatusId = pathOr(null, ["case_status", "id"], data);
        this.userExecutiveRoleId = pathOr(
          null,
          ["user_executive_role", "id"],
          data
        );
        this.calcEditable();

        this.case_status = data.case_status;
        this.exercise_guide = data.exercise_guide;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.caseLoading = false;
      }
    },
    calcEditable() {
      /*
      وضعیت پرونده: caseStatusId
      1: در حال بررسی ارزیاب
      2: در حال بررسی ناظر کیفی
      3: در حال بررسی مدیر کانون
      4: جمع‌بندی
      5: پایان فرایند ارزیابی
      6: تایید ویراستار
      7: درحال بازبینی ارزیاب
      8: درحال بازبینی ناظر کیفی

      نقش کانونی: userExecutiveRoleId
      1: شرکت کننده
      2: ارزیاب
      3: مدیر کانون
      4: ناظر کیفی
      5: واشاپر
      6: تسهیلگر
      7: ویراستار
      */
      if (
        includes(this.caseStatusId, [1, 7]) && // وضعیت ارزیاب
        includes(this.userExecutiveRoleId, [2, 3]) // ارزیاب یا مدیر
      ) {
        this.isScoreEditable = true;
        this.isEditable = true;
      }

      if (
        includes(this.caseStatusId, [2, 8]) && // وضعیت ناظر کیفی
        includes(this.userExecutiveRoleId, [4]) // ناظر کیفی
      ) {
        this.isScoreEditable = false;
        this.isEditable = true;
      }

      if (this.userExecutiveRoleId === 3) {
        this.isScoreEditable = true;
        this.isEditable = true;
      }

      if (this.caseStatusId === 4) {
        this.message =
          "به دلیل تایید کانون امکان ویرایش داده‌های کانون وجود ندارد";
      }

      if (!this.userExecutiveRoleId && this.caseStatusId !== 4) {
        this.message =
          "امکان ویرایش داده‌های پرونده‌های کانون برای شما وجود ندارد فقط افرادی که در این پرونده نقش دارند می توانند داده‌های پرونده را ویرایش کنند";
      }

      if (
        this.userExecutiveRoleId === 2 &&
        !includes(this.caseStatusId, [1, 7])
      ) {
        this.message = "بعلت تایید پرونده امکان ویرایش توسط شما وجود ندارد";
      }

      if (
        this.userExecutiveRoleId === 4 &&
        !includes(this.caseStatusId, [2, 8])
      ) {
        this.isEditable = false;
        this.message =
          "پرونده در حال بررسی ناظر کیفی نمی باشد لذا امکان ویرایش برای شما وجود ندارد";
      }
    },
    async removeItem(item) {
      try {
        const id = pathOr(null, ["id"], item);
        const url = generateApiUrl(["kanoon", "person_content_id"], [id]);
        const response = await this.$httpService.delete(url);
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      }
    },
  },
};
</script>

<style>
.header_main {
  position: absolute;
  left: 38px;
  top: 12px;
}

@media (max-width: 1300px) {
  .header_main {
    display: contents;
    position: relative;
  }
}

@media (max-width: 600px) {
  .header_main {
    position: relative;
    display: block;
    left: 0;
    top: 0;
  }
}
</style>
